import { render, staticRenderFns } from "./WidgetAddPane.vue?vue&type=template&id=18a2056d&scoped=true&"
import script from "./WidgetAddPane.vue?vue&type=script&lang=js&"
export * from "./WidgetAddPane.vue?vue&type=script&lang=js&"
import style0 from "./WidgetAddPane.vue?vue&type=style&index=0&id=18a2056d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a2056d",
  null
  
)

export default component.exports